const pragueIds = Array.from(Array(18).keys());
const prague = pragueIds.map(id => ({
    id,
    src: `contacts/office-gallery/ackee-office-gallery-prague-${id + 1}.jpg`,
    alt: `contact.prague.officeGallery.image${id + 1}.alt`,
    description: `contact.prague.officeGallery.image${id + 1}.description`,
}));

const berlinIds = Array.from(Array(8).keys());
const berlin = berlinIds.map(id => ({
    id,
    src: `contacts/office-gallery/ackee-office-gallery-berlin-${id + 1}.jpg`,
    alt: `contact.berlin.officeGallery.image${id + 1}.alt`,
    description: `contact.berlin.officeGallery.image${id + 1}.description`,
}));

export const content = {
    prague,
    berlin,
};
